export default "__VITE_ASSET__DRF2OO75__"